import {FormEvent, useId} from "react";
import {useFormContext} from "react-hook-form";
import {css} from "@panda/css";

import {FieldWrapper, InputCore, InputWrapper} from "@pg-design/inputs-module";
import {Text} from "@pg-design/text-module";

import {wizardTextInputRules} from "@/features/home_match/components/home_match_preferences_wizard/home_match_preferences_wizard_text_input_style";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "@/features/home_match/constants/preferences/home_match_preferences_wizard_content";
import {formatPhoneInputNumber, getPhoneDigits} from "@/features/purchase_guide/utils/format_phone_input_number";

import {PHONE_NUMBER_FORM_CONTENT} from "../../constants/user_content";
import {IPhoneNumberFormData} from "../../hooks/use_phone_number_patch_form";

const {PHONE_PLACEHOLDER} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;
const POLAND_CALLING_CODE = 48;

export const UserPhoneNumberInput = () => {
    const {formState, setValue, watch} = useFormContext<IPhoneNumberFormData>();
    const inputId = useId();
    const phone = watch("phone");
    const numberError = formState.errors.phone?.number?.message;

    const onNumberChange = (event: FormEvent<HTMLInputElement>) => {
        const number = getPhoneDigits(event.currentTarget.value);

        setValue("phone", {code: POLAND_CALLING_CODE, number}, {shouldDirty: true, shouldValidate: formState.isSubmitted});
    };

    return (
        <div>
            <label className={labelStyle} htmlFor={inputId}>
                <Text as="span" color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {PHONE_NUMBER_FORM_CONTENT.LABEL}
                </Text>
            </label>

            <FieldWrapper fieldState={numberError ? "error" : "default"} message={numberError}>
                <InputWrapper
                    className={phoneInputStyle}
                    fieldState={numberError ? "error" : "default"}
                    leftElement={
                        <Text color="var(--colors-secondary)" preserveFontSize variant="body_copy_2">
                            {`+${POLAND_CALLING_CODE}`}
                        </Text>
                    }
                >
                    <InputCore
                        aria-invalid={Boolean(numberError)}
                        autoComplete="tel-national"
                        className={phoneInputTextStyle}
                        data-amp-mask=""
                        id={inputId}
                        inputMode="numeric"
                        onChange={onNumberChange}
                        placeholder={PHONE_PLACEHOLDER}
                        type="tel"
                        value={formatPhoneInputNumber(POLAND_CALLING_CODE, phone?.number ?? "")}
                    />
                </InputWrapper>
            </FieldWrapper>
        </div>
    );
};

const labelStyle = css({
    display: "block",
    mb: 1
});

const phoneInputStyle = css(wizardTextInputRules, {
    overflow: "hidden"
});

const phoneInputTextStyle = css({
    color: "var(--colors-secondary)",
    fontWeight: 400,
    lineHeight: "2.1rem"
});
import {FormEvent, useId} from "react";
import {useFormContext} from "react-hook-form";
import {css} from "@panda/css";

import {FieldWrapper, InputCore, InputWrapper} from "@pg-design/inputs-module";
import {Text} from "@pg-design/text-module";

import {wizardTextInputRules} from "@/features/home_match/components/home_match_preferences_wizard/home_match_preferences_wizard_text_input_style";
import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "@/features/home_match/constants/preferences/home_match_preferences_wizard_content";
import {formatPhoneInputNumber, getPhoneDigits} from "@/features/purchase_guide/utils/format_phone_input_number";

import {PHONE_NUMBER_FORM_CONTENT} from "../../constants/user_content";
import {IPhoneNumberFormData} from "../../hooks/use_phone_number_patch_form";

const {PHONE_PLACEHOLDER} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;
const POLAND_CALLING_CODE = 48;

export const UserPhoneNumberInput = () => {
    const {formState, setValue, watch} = useFormContext<IPhoneNumberFormData>();
    const inputId = useId();
    const phone = watch("phone");
    const numberError = formState.errors.phone?.number?.message;

    const onNumberChange = (event: FormEvent<HTMLInputElement>) => {
        const number = getPhoneDigits(event.currentTarget.value);

        setValue("phone", {code: POLAND_CALLING_CODE, number}, {shouldDirty: true, shouldValidate: formState.isSubmitted});
    };

    return (
        <div>
            <label className={labelStyle} htmlFor={inputId}>
                <Text as="span" color="var(--colors-gray-900)" preserveFontSize variant="body_copy_2">
                    {PHONE_NUMBER_FORM_CONTENT.LABEL}
                </Text>
            </label>

            <FieldWrapper fieldState={numberError ? "error" : "default"} message={numberError}>
                <InputWrapper
                    className={phoneInputStyle}
                    fieldState={numberError ? "error" : "default"}
                    leftElement={
                        <Text color="var(--colors-secondary)" preserveFontSize variant="body_copy_2">
                            {`+${POLAND_CALLING_CODE}`}
                        </Text>
                    }
                >
                    <InputCore
                        aria-invalid={Boolean(numberError)}
                        autoComplete="tel-national"
                        className={phoneInputTextStyle}
                        data-amp-mask=""
                        id={inputId}
                        inputMode="numeric"
                        onChange={onNumberChange}
                        placeholder={PHONE_PLACEHOLDER}
                        type="tel"
                        value={formatPhoneInputNumber(POLAND_CALLING_CODE, phone?.number ?? "")}
                    />
                </InputWrapper>
            </FieldWrapper>
        </div>
    );
};

const labelStyle = css({
    display: "block",
    mb: 1
});

const phoneInputStyle = css(wizardTextInputRules, {
    overflow: "hidden"
});

const phoneInputTextStyle = css({
    color: "var(--colors-secondary)",
    fontWeight: 400,
    lineHeight: "2.1rem"
});
